var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "CarouselItem",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./CarouselItem.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-c61cc20c!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./CarouselItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/CarouselItem.vue
// module id = 97
// module chunks = 0